module.exports = __webpack_public_path__ + "media/images/bg/patterns/pixels-325d99bfcdfbe261c3f2b789008eedfa.svg";